import { Pipe, PipeTransform } from '@angular/core';
import { centsToDollars } from "../../shared/utils";

@Pipe({
  name: 'centsToDollars'
})

export class centsToDollarsPipe implements PipeTransform {
  transform(value: any): any {
    return centsToDollars(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/cents-to-dollars.pipe.ts